'use client';

import type { PropsWithChildren, FC } from 'react';
import S from '../../styles.base.module.scss';

/**
 * Simple component that centralizes the style of each individual nav item
 * in the mobile navigation.
 */
export const MobileNavItem: FC<PropsWithChildren> = ({ children }) => {
  return (
    /**
     * This div acts as a list item in the mobile navigation.
     * When using <li /> element it was causing the mobile menu to flashing
     * on the first render of the page. This happened because we had `li` as a descendant
     * from another `li` and this caused a rehydration error.
     */
    <div className={S.navItem} role="listitem">
      {children}
    </div>
  );
};
